<template>
  <div class="result" id="results">
    <div class="container">
      <div class="block">
        <p class="heading">
          {{ $t('global.word.results') }} ({{ lines.length }})
        </p>
        <p
          class="result-description"
          v-if="settings.step_2_result_description"
          v-html="settings.step_2_result_description"
        ></p>
      </div>

      <div class="ral-filter-container">
        <label
          v-for="(hex, ral) in ralColors"
          :key="ral"
          :style="{
            'background-color': hex,
            color: getContrastingTextColor(hex),
          }"
          class="ral-checkbox"
          :class="{ active: activeRalFilters.includes(ral) }"
        >
          <input type="checkbox" :value="ral" v-model="activeRalFilters" />
          RAL {{ ral }}
        </label>
      </div>

      <div class="line-results">
        <transition-group name="result-animation" tag="div" class="r-products">
          <LineResultsProduct
            v-for="line in filteredLines"
            :key="line.id"
            :line="line"
          />
        </transition-group>
      </div>
    </div>
  </div>
</template>

<script>
import LineResultsProduct from './LineResultsProduct';
import { mapState } from 'vuex';

export default {
  name: 'LineResults',
  components: {
    LineResultsProduct,
  },
  data() {
    return {
      activeRalFilters: [],
    };
  },
  props: {
    lines: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    getContrastingTextColor(hexcolor) {
      const r = parseInt(hexcolor.substr(1, 2), 16);
      const g = parseInt(hexcolor.substr(3, 2), 16);
      const b = parseInt(hexcolor.substr(5, 2), 16);

      const luminance = (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255;

      return luminance > 0.5 ? 'black' : 'white';
    },
  },
  computed: {
    ...mapState('data', ['settings']),
    filteredLines() {
      return this.lines.filter((line) => {
        if (this.activeRalFilters.length === 0) {
          return true;
        }

        return this.activeRalFilters.includes(line.ral_number);
      });
    },
    ralColors() {
      return this.lines.reduce((acc, curr) => {
        if (curr.ral_number !== null) {
          acc[curr.ral_number] = curr.ral_hex;
        }

        return acc;
      }, {});
    },
  },
  watch: {
    lines() {
      this.activeRalFilters = this.activeRalFilters.filter((filter) =>
        this.lines.some((line) => line.ral_number === filter)
      );
    },
  },
};
</script>
